export default __webpack_public_path__ + "static/media/github.1ac5a114.svg";